import { map } from 'lodash'
import { useCallback, useMemo } from 'react'
import { graphql, useFragment, useMutation } from 'react-relay'

import {
  type usePoliticalViewCriteria_query$data,
  type usePoliticalViewCriteria_query$key
} from '@/__generated__/usePoliticalViewCriteria_query.graphql'
import { type usePoliticalViewCriteriaMutation } from '@/__generated__/usePoliticalViewCriteriaMutation.graphql'

type CommitAsyncFn = (politicalViewIds: string[]) => Promise<usePoliticalViewCriteria_query$data>

export const usePoliticalViewCriteria = (
  queryRef?: usePoliticalViewCriteria_query$key | null | undefined
): [string[], CommitAsyncFn, boolean] => {
  const queryData = useFragment(
    graphql`
      fragment usePoliticalViewCriteria_query on Query {
        currentUser {
          politicalViewCriteria(orderBy: [POLITICAL_VIEW_BY_POLITICAL_VIEW_ID__SEQUENCE_ASC]) {
            nodes {
              politicalViewId
            }
          }
        }
      }
    `,
    queryRef
  )
  const data = useMemo(
    () => map(queryData?.currentUser?.politicalViewCriteria.nodes, 'politicalViewId'),
    [queryData?.currentUser?.politicalViewCriteria.nodes]
  )
  const [commit, isPending] = useMutation<usePoliticalViewCriteriaMutation>(graphql`
    mutation usePoliticalViewCriteriaMutation($input: UpdatePoliticalViewCriteriaInput!) {
      updatePoliticalViewCriteria(input: $input) {
        query {
          ...usePoliticalViewCriteria_query
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    (politicalViewIds: string[]) =>
      new Promise((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              // @ts-ignore false negative
              resolve(response)
            }
          },
          variables: {
            input: {
              politicalViewIds
            }
          }
        })
      ),
    [commit]
  )

  return [data, commitAsync, isPending]
}
